/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Tabs as MantineTabs, type MantineTheme, createTheme } from '@mantine/core';

import * as classes from './tabs.css';

export const tabsTheme = createTheme({
  components: {
    Tabs: MantineTabs.extend({
      defaultProps: {
        placement: 'right',
      },
      classNames: () => ({
        root: classes.root,
        list: classes.list,
        tab: classes.tab,
        tabLabel: classes.tabLabel,
        tabSection: classes.tabSection,
      }),
    }),
  },
}) as MantineTheme;
